<template>
  <v-app id="inspire">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
    ></loading>
    <v-main>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="primary">
                <v-toolbar-title>{{
                  $t("users.forgot_password")
                }}</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-text-field
                  v-model.trim="email"
                  label="Email"
                  required
                ></v-text-field>
                <v-flex class="text-center">
                  <v-btn @click="submit()" color="primary">{{
                    $t("users.recover_password")
                  }}</v-btn>
                  <div class="mt-2">
                    <router-link to="/signin">{{
                      $t("users.enter")
                    }}</router-link>
                    <br v-if="!isNative" />
                    <router-link v-if="!isNative" to="/signup">{{
                      $t("users.registration")
                    }}</router-link>
                  </div>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { Capacitor } from "@capacitor/core";
import { supportedLocale } from "@/utils/localeInfra";
export default {
  data() {
    return {
      email: null,
      error: "",
      notice: "",
      show1: false,
      isLoading: false,
    };
  },
  computed: {
    isNative() {
      return Capacitor.getPlatform().toLowerCase() == "ios" ||
        Capacitor.getPlatform().toLowerCase() == "android"
        ? true
        : false;
    },
  },
  created() {
    // Лендинг ведёт сюда со ссылки «Забыли пароль?» с ?locale= своей страницы — как на /signin.
    this.applyLocale(this.$route.query && this.$route.query.locale);
  },
  methods: {
    applyLocale(candidate) {
      const locale = supportedLocale(candidate, Object.keys(this.$i18n.messages));
      if (locale) this.$i18n.locale = locale;
    },
    submit() {
      let self = this;
      this.isLoading = true;
      if (this.email) {
        this.axios
          .post("/api/v1/restore_password", {
            email: this.email,
          })
          .then(() => {
            // API отвечает 200 на любой корректный адрес и не говорит, есть ли аккаунт
            // (закрыт оракул существования) — сообщение нейтральное.
            this.$notify(this.$t("users.send_request"), this.$t("users.send_instructions_if_exists"), "success", 8000);
            this.isLoading = false;
            this.$router.push({ path: `/signin` }).catch((err) => {});
          })
          .catch((error) => {
            this.isLoading = false;
            // 404 — старые сборки API (неизвестный адрес) и новая на адрес не той формы.
            if (
              error.response &&
              error.response?.status &&
              error.response?.status == 404
            ) {
              this.setError(error, this.$t("errors.pass_recover"));
              this.$notify(this.$t("errors.no_find_email"), error, "error", 5000);
              console.log(error);
            } else {
              this.setError(error, this.$t("errors.pass_recover"));
              this.$notify(this.$t("errors.pass_recover_long"), error, "error", 5000);
              console.log(error);
            }
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.enter_email"), "", "warning", 5000);
      }
    },
  },
};
</script>
